module.exports = __webpack_public_path__ + "static/media/active_dashboard.ca6681cd.svg";